import { useState, useCallback } from "react";
import { getAxios } from "../utils/axios";
const endpoint = "/inventory/media";
export const useInventoryMedia = () => {
    const [media, setMedia] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchAll = useCallback(async (filter, options) => {
        setLoading(true);
        setError(null);
        try {
            const normalizedFilter = { ...filter };
            if (normalizedFilter?.media_type === "video") {
                normalizedFilter.media_type = ["video", "videos"];
            }
            if (normalizedFilter?.media_type === "picture") {
                normalizedFilter.media_type = ["picture", "pictures"];
            }
            const params = new URLSearchParams();
            if (normalizedFilter) {
                params.set("filter", JSON.stringify(normalizedFilter));
            }
            params.set("offset", String(options?.offset ?? 0));
            params.set("limit", String(options?.limit ?? 100));
            const res = await getAxios().get(`${endpoint}?${params.toString()}`);
            const normalized = Array.isArray(res.data)
                ? res.data.map((entry) => ({
                    ...entry,
                    media_type: entry?.media_type === "videos"
                        ? "video"
                        : entry?.media_type === "pictures"
                            ? "picture"
                            : entry?.media_type,
                }))
                : [];
            setMedia(normalized);
        }
        catch (err) {
            setError(err.message || "Failed to fetch media.");
        }
        finally {
            setLoading(false);
        }
    }, []);
    const create = async (payload) => {
        const res = await getAxios().post(endpoint, payload);
        await fetchAll({ item_id: payload.item_id, media_type: payload.media_type });
        return res.data;
    };
    const update = async (uuid, payload) => {
        const res = await getAxios().put(`${endpoint}/${uuid}`, payload);
        await fetchAll({ item_id: payload.item_id, media_type: payload.media_type });
        return res.data;
    };
    const patch = async (uuid, payload) => {
        const res = await getAxios().patch(`${endpoint}/${uuid}`, payload);
        await fetchAll({ item_id: payload.item_id, media_type: payload.media_type });
        return res.data;
    };
    const remove = async (uuid, filter) => {
        const res = await getAxios().delete(`${endpoint}/${uuid}`);
        await fetchAll(filter);
        return res.data;
    };
    return { media, loading, error, fetchAll, create, update, patch, remove };
};
